async function getCpt(param) {
  const response = await fetch(
    process.env.REACT_APP_WP_ADMIN_URL + '/wp-json/wp/v2/' + param
  );
  console.log(process.env.REACT_APP_WP_ADMIN_URL + '/wp-json/wp/v2/' + param);
  return await response.json();
}

export default getCpt;
